module.exports = __webpack_public_path__ + "static/media/card-image-one.0cf3e9cd.png";